<template lang="pug">
.col-12.table_item
  .table_item_title.d-flex(@click="expand", :class="{ expand: isExpand }")
    .date_block {{ tableItem.SpeechDate }}
    .time_block {{ tableItem.SpeechTime }}
    .subject_block {{ tableItem.Brief }}
    svg-icon.i_ml_1(
      :class="{ expand: isExpand }",
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g"
    )
  .table_item_content.container-fluid(ref="tableitem")
    .row
      .title.title_1.i_body 發言日期
      .content.content_1.i_body_l {{ tableItem.SpeechDate }}
      .title.title_2.i_body 發言時間
      .content.content_2.i_body_l {{ tableItem.SpeechTime }}
    .row
      .title.title_1.i_body 發言人
      .content.content_1.i_body_l {{ tableItem.SpeechPeople }}
      .title.title_2.i_body 發言人職稱
      .content.content_2.i_body_l {{ tableItem.Title }}
    .row
      .title.title_1.i_body 發言人電話
      .content.content_span.i_body_l {{ tableItem.SpeechTel }}
    .row
      .title.title_1.i_body 主旨
      .content.content_span.i_body_l {{ tableItem.Brief }}
    .row
      .title.title_1.i_body 符合條款
      .content.content_span.i_body_l {{ tableItem.Terms }}
    .row
      .title.title_1.i_body 事實發生日
      .content.content_span.i_body_l {{ tableItem.DateofFact }}
    .row
      .title.title_1.i_body 說明
      .content.content_span.i_body_l(v-html="tableItem.Description")
</template>

<script>
import Velocity from "velocity-animate";

export default {
  name: "TableItem",
  data() {
    return {
      isExpand: false,
      screenWidth: document.documentElement.clientWidth, //螢幕寬度
    };
  },
  props: {
    tableItem: Object,
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    expand() {
      this.isExpand = !this.isExpand;

      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.tableitem.scrollHeight + 20;

        Velocity(
          this.$refs.tableitem,
          { maxHeight: height, opacity: 1 },
          { duration: 300 }
        );
      } else {
        Velocity(
          this.$refs.tableitem,
          { maxHeight: 0, opacity: 0 },
          { duration: 300 }
        );
      }
    },
  },
  watch: {
    "$store.state.screenWidth": function () {
      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.tableitem.scrollHeight + 20;

        Velocity(
          this.$refs.tableitem,
          { maxHeight: height, opacity: 1 },
          { duration: 0 }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/public_info/table_item";
</style>
